import { render, staticRenderFns } from "./ClientActivityList.vue?vue&type=template&id=18c1fbd6&"
import script from "./ClientActivityList.vue?vue&type=script&lang=js&"
export * from "./ClientActivityList.vue?vue&type=script&lang=js&"
import style0 from "./ClientActivityList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClientActivityList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports